var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about-us-headline"},[_c('h1',{staticClass:"about-us-headline__title"},[_c('span',[_vm._v("\n      "+_vm._s(_vm.$t('firstSection.aboutUs'))+"\n    ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }